<template>
    <div class="bg-wrap">
        <div class="timer">
            <span>{{timeShow}}</span>
        </div>
        <div class="scroll">
            <div class="kv">
                <div class="title">
                    {{title}}
                </div>
            </div>
            <div class="content-wrap">
                <div class="content">
                    <div class="item" v-for="(value,i) in questions" v-bind:key="i">
                    <span class="index">
                        {{i+1}}.
                    </span>
                        <span class="info">
                        <span class="answer-key">
                           {{value.question}} {{titleHint(value.sort)}}
                        </span>
                        <span class="answer-value" :id="value.questionId+'-'+v.resolve_order" :class="'-'+value.questionId" v-for="(v,index) in value.resolves" v-bind:key="index" @click="check($event,value.sort)" data-light="0" :data-order="v.resolve_order">
                            {{v.resolve_order}}、{{v.resolve}}
                        </span>
                    </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="tap">
            </div>
            <div class="submit" @click="questionSubmit">
                <span>{{submit}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {answerSubmit, myQuestion} from "@/assets/js/api";

    export default {
        data() {
            return {
                title: "B卷 竞答题题（每题2分，答题时间1分钟）",
                hint: "（每题1分，共10道题目，答题时间5分钟）",
                submit: "提交",
                questions: [],
                answer:[],
                timeShow:'',
                seconds:60,
                id:"",
                playerId: this.$store.state.playerId,
                type:2
            }
        },
        methods:{
            titleHint(sort){
                switch (sort) {
                    case 1:
                        return "(单选题)"
                    case 2:
                        return "(判断题)"
                    case 3:
                        return "(多选题)"
                    default:
                        return ""
                }
            },
            showTime(second){
                var h;
                h  =   Math.floor(second/60);
                //计算秒
                //算法：取得秒%60的余数，既得到秒数
                second = second%60;
                //将变量转换为字符串
                h += '';
                second += '';
                //如果只有一位数，前面增加一个0
                h  =   (h.length==1)?'0'+h:h;
                second  =   (second.length==1)?'0'+second:second;
                this.timeShow = h+':'+second
            },
            checkIndex(index){
                let charCode;
                let value =  index.toString(26).split("").map(function(item){
                    charCode = item.charCodeAt(0);
                    charCode+=(charCode>=97?10:49);
                    return String.fromCharCode(charCode)
                }).join("").toUpperCase();
                return value;
            },
            check(event,sort){
                // console.log(event.currentTarget,"targetid========")

                let id = event.currentTarget.id;
                // console.log(id,"id===")
                let group =  id.split("-")[0];
                let groupValue = id.split("-")[1];

                if(sort==1||sort==2){ //单选或者判断题才会清除别的题目的高显
                    let value = document.getElementsByClassName('-'+group);
                    for(let i=0;i<value.length;i++){
                        value[i].style.background = "transparent"
                    }
                    document.getElementById(event.currentTarget.id).style.background="#036eb7";
                    document.getElementById(event.currentTarget.id).style.borderRadius="5px"
                }
                if(sort==3){//多选的情况下
                    groupValue=""
                    let light =  document.getElementById(event.currentTarget.id).getAttribute("data-light");
                    if(light==1){
                        document.getElementById(event.currentTarget.id).style.background="transparent";
                        document.getElementById(event.currentTarget.id).setAttribute("data-light","0");
                    } else{
                        document.getElementById(event.currentTarget.id).style.background="#036eb7";
                        document.getElementById(event.currentTarget.id).style.borderRadius="5px"
                        document.getElementById(event.currentTarget.id).setAttribute("data-light","1");
                    }

                    let value = document.getElementsByClassName('-'+group);
                    for(let i=0;i<value.length;i++){
                        if(value[i].getAttribute("data-light")==1){
                            groupValue+= value[i].getAttribute("data-order")+"、"
                        }
                    }
                }

                console.log(groupValue,"===groupValue===")

                for(let question of this.questions){
                    if(question.questionId==group){
                        console.log("questionId",group)
                        question["myResolve"] = groupValue;
                    }
                }

            },
            questionSubmit(){
                /**
                 * 开始检查所有题目
                 */
                let i=1;
                for(let question of this.questions){
                    if(question.myResolve==null){
                        this.$toast("请选择第"+i+"题目")
                        return
                    }
                    i++
                }
                this.toAnswerSubmit(this.playerId,this.questions)
            },
            async toAnswerSubmit(playerId,answer){
                const res = await answerSubmit({playerId,answer})
                if(res.data.success==true){
                    this.$router.replace({path:"/playerCompAnswerBtn",query:{type:2}})

                    this.$toast("提交成功");
                }
            },
            async getMyQuestion(playerId,type){
                const  res = await myQuestion({playerId,type})
                this.questions = res.data.data
                console.log(res,"myqeustion==")
            }
        },
        mounted(){
            this.getMyQuestion(this.playerId,this.type)//获取我的题目

            this.id= setInterval(()=>{
               --this.seconds;
               this.showTime(this.seconds);
               if(this.seconds<=0){
                   clearInterval(this.id);
               }
            },1000)
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        display: flex;
        flex-flow: column;
        position: relative;
    }

    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }

    .kv .title {
        position: absolute;
        bottom: 0;
        color: #FFF;
        font-size: 13px;
        width: 90%;
        background: #036eb7;
        border-radius: 5px;
        height: 28px;
        line-height: 28px;
        margin-left: 20px;
        opacity: 0.8    ;
    }

    .scroll{
        flex-grow: 1;
        overflow: scroll;
    }

    .content-wrap {
        display: flex;
        flex-flow: column;
        align-items: center;
        position: relative;
    }

    .content {
        margin-top: 20px;
        height: 300px;
        width: 100%;
        overflow: auto;
        margin-bottom: 50px;
    }

    .bottom{
        width: 100%;
        /*height: 120px;*/
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tap{
            width: 120px;
            height: 60px;
            background: transparent url("../../assets/img/answer_tap.png") no-repeat;
            background-size: 100% 100%;
            margin-left: 10px;
        }
        .submit{
            width: 90px;
            height: 24px;
            color: #FFF;
            line-height: 24px;
            background: #036eb7;
            font-size: 13px;
            border-radius: 5px;
            margin-right: 30px;
        }
    }

    .timer {
        position: absolute;
        right: 20px;
        top: 50px;
        width: 90px;
        height: 24px;
        line-height: 24px;
        font-size: 30px;
        font-weight: bold;
        color: #ffc336;
        border-radius: 5px;
        z-index: 100;
    }

    .item{
        display: flex;
        flex-flow: row;
        align-items: flex-start;
        color: #FFF;
        font-size: 13px;
        margin: 10px;
        text-align: left;
        .index{
            margin: 2px 10px 0 10px;
        }
        .info{
            display: flex;
            flex-flow: column;
            padding-bottom: 20px;
            /*border-bottom: 1px #b30b19 solid;*/
            flex-grow: 1;
        }
    }
    .info .answer-key{
        word-wrap:normal;
        word-break:break-all;
        margin-bottom: 5px;
    }
    .info .answer-value{
        margin: 2px 0;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        /*background: #F29600;*/
        /*color: #F29600;*/
        input[type="checkbox"]{
            margin-right: 50px;
        }
    }


    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    /*::-webkit-scrollbar*/
    /*{*/
    /*    width: 3px;*/
    /*    height: 3px;*/
    /*    background-color: #FFF;*/
    /*    border-radius: 10px;*/
    /*}*/

    /*定义滚动条轨道 内阴影+圆角*/
    /*::-webkit-scrollbar-track*/
    /*{*/
    /*    !*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*!*/
    /*    !*border-radius: 10px;*!*/
    /*    !*background-color: #F5F5F5;*!*/
    /*}*/

    /*定义滑块 内阴影+圆角*/
    /*::-webkit-scrollbar-thumb*/
    /*{*/
    /*    border-radius: 10px;*/
    /*    !*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,1);*!*/
    /*    background-color: #F29600;*/
    /*}*/

</style>